import axios from 'axios';
import { API_BASE_URL } from '../../../../constants';

// Coach profile hub API (backend/users/coach_profile_views.py). A refused
// call throws an Error carrying the server's sentence, and for a refused
// save each field's message on `fields`.

const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });

const call = async (method, path, data) => {
  try {
    const res = await axios({ method, url: `${API_BASE_URL}${path}`, data, headers: headers() });
    return res.data;
  } catch (e) {
    const body = e.response?.data && typeof e.response.data === 'object' ? e.response.data : {};
    const err = new Error(body.message || body.error || 'Something went wrong. Try again.');
    err.fields = body.fields && typeof body.fields === 'object' ? body.fields : {};
    throw err;
  }
};

// -> {account, verification, team, additionalTeams, leagueAdmin}
export const fetchCoachProfile = () => call('get', '/coach/profile/');
// -> {account}
export const updateCoachAccount = ({ firstName, lastName }) => call('patch', '/coach/profile/', { firstName, lastName });
// -> {sent, invalid, skipped}. Sends the code of `team` ({teamId, league},
// one of the coach's own) when given, else the primary team's.
export const shareCoachCode = (emails, team) =>
  call('post', '/coach/share-code/', team?.teamId ? { emails, teamId: team.teamId, league: team.league || '' } : { emails });
